// Passkeys (WebAuthn): de server stuurt JSON met base64url-tekst, de browser-API
// wil ArrayBuffers, en het antwoord moet weer terug naar JSON. Pure functies,
// zonder DOM, zodat vitest ze kan testen (test/javascript/webauthn_json.test.js).
// Bewust geen npm-pakket: het is weinig code, en @github/webauthn-json is
// uitgefaseerd.

export function base64urlToBuffer (value) {
  const b64 = String(value).replace(/-/g, '+').replace(/_/g, '/')
  const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4)
  const binary = atob(padded)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
  return bytes.buffer
}

export function bufferToBase64url (buffer) {
  const bytes = buffer instanceof ArrayBuffer ? new Uint8Array(buffer) : new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength)
  let binary = ''
  for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i])
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

const withIds = (list) => (list || []).map((c) => ({ ...c, id: base64urlToBuffer(c.id) }))

// Opties voor navigator.credentials.create (een passkey toevoegen).
export function toCreationOptions (json) {
  return {
    ...json,
    challenge: base64urlToBuffer(json.challenge),
    user: { ...json.user, id: base64urlToBuffer(json.user.id) },
    excludeCredentials: withIds(json.excludeCredentials),
  }
}

// Opties voor navigator.credentials.get (inloggen of de tweede stap).
export function toRequestOptions (json) {
  const out = { ...json, challenge: base64urlToBuffer(json.challenge) }
  if (json.allowCredentials) out.allowCredentials = withIds(json.allowCredentials)
  return out
}

// Het antwoord van de browser als JSON, in de vorm die de webauthn-gem leest.
export function credentialToJSON (credential) {
  const r = credential.response
  const out = {
    id: credential.id,
    rawId: bufferToBase64url(credential.rawId),
    type: credential.type,
    authenticatorAttachment: credential.authenticatorAttachment || null,
    clientExtensionResults: typeof credential.getClientExtensionResults === 'function' ? credential.getClientExtensionResults() : {},
    response: { clientDataJSON: bufferToBase64url(r.clientDataJSON) },
  }
  if (r.attestationObject) {
    out.response.attestationObject = bufferToBase64url(r.attestationObject)
    out.response.transports = typeof r.getTransports === 'function' ? r.getTransports() : []
  }
  if (r.authenticatorData) {
    out.response.authenticatorData = bufferToBase64url(r.authenticatorData)
    out.response.signature = bufferToBase64url(r.signature)
    out.response.userHandle = r.userHandle ? bufferToBase64url(r.userHandle) : null
  }
  return out
}

// Kan deze browser passkeys? (Oude browsers, of een pagina buiten https.)
export function passkeysSupported (win = globalThis) {
  return !!(win && win.PublicKeyCredential && win.navigator && win.navigator.credentials &&
    typeof win.navigator.credentials.create === 'function')
}
